import { render, staticRenderFns } from "./ResourceImage.vue?vue&type=template&id=9abc68f6"
import script from "./ResourceImage.vue?vue&type=script&lang=js"
export * from "./ResourceImage.vue?vue&type=script&lang=js"
import style0 from "./ResourceImage.vue?vue&type=style&index=0&id=9abc68f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports